import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Popup, PopupPosition } from 'react-vant';
import { SelectOption } from '../../types';
import { readLandingSearchParams } from '../../utils/landingPage';
import { callDurationData, operatorsTypeData, priceData } from '../../utils/source';
import area from '../m_city_picker/area.json';
interface Props {
  currentProvince?: string; //默认省份
  mobileNetParam?: string;
  goodsTypeParam?: string;
  goodsNameParam?: string;
  position?: PopupPosition;
  height?:number | string;
  goodsTypeOptions: SelectOption[];
  onClose: () => void;
  onConfirm: () => void;
}
export default function ScreenDialog({
  currentProvince,
  mobileNetParam,
  goodsTypeParam,
  goodsNameParam,
  goodsTypeOptions,
  position,
  height,
  onClose,
  onConfirm,
}: Props) {
  const navMenuList: { name: string; id: string }[] = useMemo(() => {
    return [
      { name: '商品名称', id: 'section-name' },
      { name: '产品类型', id: 'section-product' },
      { name: '价格区间', id: 'section-price' },
      { name: '收货地', id: 'section-area' },
      { name: '运营商', id: 'section-operator' },
      { name: '是否含通话', id: 'section-call' },
    ];
  }, []);
  // 左侧导航栏的ref，用于处理滚动
  const navRef = useRef<HTMLDivElement>(null);
  // 右侧内容区域的ref，用于监听滚动
  const contentRef = useRef<HTMLDivElement>(null);
  // 当前激活的导航项索引
  const [activeNav, setActiveNav] = useState<string>(navMenuList[0].id);
  // 地区-展开/收起
  const [moreAreaFlag, setmoreAreaFlag] = useState<boolean>(false);
  // 区分左侧点击或者右侧滚动高亮
  const isLeftClickRef = useRef<boolean>(false);
  let searchParams = readLandingSearchParams();
  let searchVal = sessionStorage.getItem('searchIptValue') ?? '';
  // ------筛选条件----开始-----------
  const [activeDotId, setActiveDotId] = useState<string[]>(searchParams?.activeDotId ?? [navMenuList[0].id]);
  const [goodsType, setgoodsType] = useState<string>(goodsTypeParam ?? searchParams?.goodsType);
  const [goodsName, setgoodsName] = useState<string>(goodsNameParam ?? searchVal);
  const [priceStart, setpriceStart] = useState<number | string>(searchParams?.priceStart ?? '');
  const [priceEnd, setpriceEnd] = useState<number | string>(searchParams?.priceEnd ?? '');
  const [priceValue, setpriceValue] = useState<string | undefined>(searchParams?.priceValue ?? '');
  const [receiverAddress, setreceiverAddress] = useState<string | undefined>(searchParams?.receiverAddress);
  const [mobileNet, setmobileNet] = useState<string>(mobileNetParam ?? searchParams?.mobileNet);
  const [callDuration, setcallDuration] = useState<string>(searchParams?.callDuration ?? '');
  // ------筛选条件----结束-----------

  // 监听滚动事件，自动更新激活的导航项
  useEffect(() => {
    const handleScroll = () => {
      if (!contentRef.current) return;
      if (isLeftClickRef.current) return;

      const contentTop = contentRef.current.getBoundingClientRect().top;
      let currentVisibleId = navMenuList[0].id;
      let minDistance = Infinity;

      // 遍历所有区域，找到顶部距离可视区域顶部最近的区域
      navMenuList.forEach((navItem) => {
        const element = document.getElementById(navItem.id);
        if (!element) return;

        const rect = element.getBoundingClientRect();
        // 计算区域顶部与可视区域顶部的距离（取正值）
        const distance = Math.abs(rect.top - contentTop);

        // 找到距离最近的区域
        if (distance < minDistance) {
          minDistance = distance;
          currentVisibleId = navItem.id;
        }
      });
      if (currentVisibleId !== activeNav) {
        setActiveNav(currentVisibleId);
        if (navRef.current) {
          const activeElement = navRef.current.querySelector(`[data-nav-id="${currentVisibleId}"]`);

          if (activeElement) {
            activeElement.scrollIntoView({ block: 'nearest' });
          }
        }
      }
    };

    const contentElement = contentRef.current;
    if (contentElement) {
      contentElement.addEventListener('scroll', handleScroll);
      handleScroll();
    }

    // 清理事件监听
    return () => {
      if (contentElement) {
        contentElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, [activeNav, navMenuList]);

  useEffect(() => {
    setActiveDotId(!!goodsName ? activeDotId.concat('section-name') : activeDotId.filter((i) => i !== 'section-name'));
  }, [goodsName]); // eslint-disable-line

  // 平滑滚动到指定区域
  const scrollToSection = (id: string, e?: React.MouseEvent) => {
    e?.preventDefault();
    setActiveNav(id);
    isLeftClickRef.current = true;
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setTimeout(() => {
      isLeftClickRef.current = false;
    }, 500);
  };

  const handleConfirm = () => {
    let param = {
      ...searchParams,
      goodsType,
      priceStart,
      priceEnd,
      priceValue,
      receiverAddress,
      activeDotId,
      mobileNet: mobileNet ? mobileNet : 'all',
      callDuration,
      pageNum: 1,
    };
    sessionStorage.setItem('searchParams', JSON.stringify(param));
    sessionStorage.setItem('searchIptValue', goodsName);
    onConfirm();
  };
  const handleClear = () => {
    setgoodsType(goodsTypeOptions[0]?.value ?? 'order');
    setmobileNet('all');
    setpriceStart('');
    setpriceEnd('');
    setpriceValue('');
    setreceiverAddress('');
    setcallDuration('');
    setgoodsName('');
    setActiveDotId([navMenuList[1].id]);
    let param = {
      ...searchParams,
      pageNum: 1,
      activeDotId: [navMenuList[1].id],
    };
    sessionStorage.setItem('searchParams', JSON.stringify(param));
    sessionStorage.removeItem('searchIptValue');
  };

  // 省份数据调整-将获取ip地址省份排列第一个
  const provinceArea = [...area];
  let index: any = currentProvince && provinceArea.findIndex((item) => item.label.includes(currentProvince));
  if (index !== -1) {
    let itemToMove = provinceArea.splice(index, 1)[0];
    itemToMove && provinceArea.unshift(itemToMove);
  }
  let areaOptions = provinceArea.map((item) => ({
    value: item?.label,
    label: item?.label.includes('黑龙江') ? '黑龙江' : item?.label.substring(0, 2),
  }));

  return (
    <Popup
      visible
      style={{
        height: height || '80%',
        borderRadius: '16px 16px 0 0',
      }}
      position={(position || 'bottom') || "bottom"}
    >
      <div className="d-flex-c bh-100 screen-dialog">
        <div className="h-50 d-flex-r ai-center jc-between pl-12 pr-12">
          <div className="w-30 h-1"></div>
          <span className="font-size-18 font-widget-600">全部筛选</span>
          <span className="font-size-14 text-color-3" onClick={onClose}>
            取消
          </span>
        </div>
        <div className="d-flex-r pos-r flex-1 bh-100 overflow-hidden">
          {/* 左侧导航栏 - 固定不滚动 */}
          <div ref={navRef} className="bh-100 w-100 border-r bg-gray">
            {navMenuList.map((item, idx) => (
              <div
                data-nav-id={item.id}
                className={`d-flex-r ai-center jc-center text-center h-40 line-height-40 font-size-14 text-color-3 ${
                  activeNav === item.id && 'active-nav'
                } `}
                key={idx}
                onClick={() => scrollToSection(item.id)}
              >
                <div
                  className={`w-5 h-5 border-radius-40 bg-white-t mr-5 ${activeDotId.includes(item.id) && 'bg-p'}`}
                ></div>
                {item.name}
              </div>
            ))}
          </div>
          {/* 右侧内容区域 - 可滚动 */}
          <div ref={contentRef} className="flex-1 overflow-y">
            <div id="section-name" className="line-height-40 pl-12 pr-12 mb-10">
              <div className="font-size-16 font-widget-600">商品信息</div>
              <div className="d-flex-r ai-center jc-between">
                <span>商品名称</span>
                <div className="search-ipt-block border d-flex-r bg-white pl-10 pr-3 pt-5 pb-5 m-10 border-radius-8 pos-r">
                  <input
                    className="input-block flex-1"
                    type="text"
                    placeholder="输入关键字搜索您想要的商品"
                    value={goodsName}
                    onChange={(v) => {
                      setgoodsName(v.target.value);
                    }}
                  />
                  <div className="pos-a r-2 t-3 d-flex-r ai-center">
                    {!!goodsName && (
                      <img
                        className="w-20 h-20"
                        src="/pic/icon_clear.png"
                        alt=""
                        onClick={(e) => {
                          e.stopPropagation();
                          setgoodsName('');
                          sessionStorage.removeItem('searchIptValue');
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div id="section-product" className="line-height-40 pl-12 pr-12 mb-10">
              <div className="font-size-16 font-widget-600">产品类型</div>
              <div className="d-flex-r ai-center flex-wrap jc-between">
                {goodsTypeOptions.map((item, idx) => (
                  <div
                    className={`content-tag flex-1 bg-gray mr-5 text-color-3 text-center border-radius-4 ${
                      item.value === goodsType && 'active'
                    }`}
                    key={idx}
                    onClick={() => {
                      setActiveDotId(
                        item.value !== goodsType
                          ? activeDotId.concat('section-product')
                          : activeDotId.filter((i) => i !== 'section-product')
                      );
                      setgoodsType(item?.value === goodsType ? '' : item?.value);
                    }}
                  >
                    {item.label}
                  </div>
                ))}
              </div>
            </div>

            <div id="section-price" className="pl-12 pr-12">
              <div className="font-size-16 font-widget-600">价格区间</div>
              <div className="mt-10 d-flex-r ai-center flex-wrap jc-between">
                {priceData.map((item, idx) => (
                  <div
                    className={`operators-tag p-3 bg-gray mr-5 text-color-3 text-center mb-10 d-flex-c ${
                      (priceStart === item.minVal && priceEnd === item.maxVal) || priceValue === item.value
                        ? 'active'
                        : ''
                    }`}
                    key={idx}
                    onClick={() => {
                      let flag = priceValue === item.value;
                      setpriceStart(flag ? '' : item?.minVal);
                      setpriceValue(flag ? '' : item?.value);
                      item?.maxVal && !flag ? setpriceEnd(item?.maxVal) : setpriceEnd('');
                      setActiveDotId(
                        !flag ? activeDotId.concat('section-price') : activeDotId.filter((i) => i !== 'section-price')
                      );
                    }}
                  >
                    <span className="line-height-20">{item.label}</span>
                    <span className="line-height-20 font-size-10">{item.scale}的选择</span>
                  </div>
                ))}
              </div>
              <div className="flex-1 d-flex-r ai-center">
                <input
                  type="number"
                  value={priceStart}
                  className="flex-1 input"
                  placeholder="自定义最低价"
                  onChange={(v) => {
                    setpriceStart(v.target.value);
                    setpriceValue(undefined);
                  }}
                />
                <input
                  type="number"
                  value={priceEnd}
                  className="flex-1 input"
                  placeholder="自定义最高价"
                  onChange={(v) => {
                    setpriceEnd(v.target.value);
                    setpriceValue(undefined);
                  }}
                />
              </div>
            </div>

            <div id="section-area" className="line-height-40 pl-12 pr-12 mb-10">
              <div className="d-flex-r ai-center jc-between">
                <div className="font-size-16 font-widget-600">收货地</div>
                <div className="d-flex-r ai-center">
                  {currentProvince && (
                    <div className="font-size-12 text-color-6 mr-10">当前位置：{currentProvince}</div>
                  )}
                  {moreAreaFlag && (
                    <div
                      className="font-size-12 text-color-3 d-flex-r ai-center jc-center"
                      onClick={() => setmoreAreaFlag(false)}
                    >
                      <span>收起</span>
                      <img className="w-14 ml-2" src="/pic/icon_shout.png" alt="" />
                    </div>
                  )}
                </div>
              </div>
              <div className="d-flex-r ai-center flex-wrap">
                {areaOptions.map((item, idx) => (
                  <div
                    className="area-tag"
                    key={idx}
                    onClick={() => {
                      setreceiverAddress(item.label === receiverAddress ? '' : item.label);
                      setActiveDotId(
                        item.label !== receiverAddress
                          ? activeDotId.concat('section-area')
                          : activeDotId.filter((i) => i !== 'section-area')
                      );
                    }}
                  >
                    {idx === 0 && (
                      <div
                        className={`bg-gray mr-5 mb-5 text-color-3 text-center d-flex-r ai-center jc-center ${
                          item.label === receiverAddress && 'active'
                        }`}
                      >
                        <img className="w-14 mr-2" src="/pic/icon_position.png" alt="" />
                        <span>{item.label}</span>
                      </div>
                    )}
                    {idx <= 4 && idx > 0 && (
                      <div
                        className={`bg-gray mr-5 mb-5 text-color-3 text-center ${
                          item.label === receiverAddress && 'active'
                        }`}
                      >
                        {item.label}
                      </div>
                    )}
                    {idx === 5 && !moreAreaFlag && (
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          setmoreAreaFlag(true);
                        }}
                        className="text-color-3 bg-gray mb-5 mr-5 d-flex-r ai-center jc-center"
                      >
                        <span>更多</span>
                        <img className="w-14 ml-2" src="/pic/icon_expand.png" alt="" />
                      </div>
                    )}
                    {idx > 4 && moreAreaFlag && (
                      <div
                        className={` bg-gray mr-5 mb-5 text-color-3 text-center ${
                          item.label === receiverAddress && 'active'
                        }`}
                      >
                        {item.label}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            <div id="section-operator" className="line-height-40 pl-12 pr-12 mb-10">
              <div className="font-size-16 font-widget-600">运营商</div>
              <div className="d-flex-r ai-center flex-wrap jc-between">
                {operatorsTypeData.map((item, idx) => (
                  <div
                    className={`operators-tag bg-gray mr-5 text-color-3 text-center mb-5 ${
                      mobileNet === item.value && 'active'
                    }`}
                    key={idx}
                    onClick={() => {
                      setmobileNet(mobileNet === item.value ? '' : item.value);
                      setActiveDotId(
                        item.value !== mobileNet
                          ? activeDotId.concat('section-operator')
                          : activeDotId.filter((i) => i !== 'section-operator')
                      );
                    }}
                  >
                    {item.label}
                  </div>
                ))}
              </div>
            </div>

            <div id="section-call" className="line-height-40 pl-12 pr-12 mb-10">
              <div className="font-size-16 font-widget-600">是否含通话</div>
              <div className="d-flex-r ai-center flex-wrap jc-between">
                {callDurationData.map((item, idx) => (
                  <div
                    className={`content-tag flex-1 bg-gray mr-5 text-color-3 text-center ${
                      callDuration === item.value && 'active'
                    }`}
                    key={idx}
                    onClick={() => {
                      setcallDuration(callDuration === item.value ? '' : item.value);
                      setActiveDotId(
                        item.value !== callDuration
                          ? activeDotId.concat('section-call')
                          : activeDotId.filter((i) => i !== 'section-call')
                      );
                    }}
                  >
                    {item.label}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        {/* 底部操作区 */}
        <div className="h-50 p-8 d-flex-r ai-center">
          <button onClick={handleClear} className="flex-1 mr-12 cancel-btn btn">
            清空筛选
          </button>
          <button onClick={handleConfirm} className="flex-1 confirm-btn btn bg-p text-color-white">
            确定
          </button>
        </div>
      </div>
    </Popup>
  );
}
